import { createContext } from "react";
import { Playlist } from "../../types/Playlist";
import { Artist } from "../../types/Artist";
import { Album } from "../../types/Album";
import { Track } from "../../types/Track";

export interface PlaylistModalContextType {
    playlistModalOpen: boolean;
    setPlaylistModalOpen: (open: boolean) => void;
    playlists: Playlist[];
    artist: Artist | undefined;
    album: Album | undefined;
    track: Track | undefined;
    selectedPlaylistIds: string[];
    applyItemToPlaylists: (artist: Artist | undefined, album: Album | undefined, track: Track | undefined) => void;
    handleTrackPlaylistChange: (selected: boolean, playlistId: string) => void;
    handleSave: () => void;
}

const PlaylistModalContext = createContext<PlaylistModalContextType | undefined>(undefined);

export default PlaylistModalContext;